import axios from 'axios'
import get from 'lodash/get'

const params = (newParams = {}) => {
  const { step = 1, ...others } = newParams

  return {
    step,
    ...others,
  }
}

const getStuff = async (payload) => {
  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/${get(payload, 'consultantId')}/tip`, {
      ...params(payload)
    })

    return data
  } catch (e) {
    throw e
  }
}

const sendResultClick = async (payload) => {
  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/${get(payload, 'consultantId')}/tip`, {
      ...params(payload)
    })

    return data
  } catch (e) {
    throw e
  }
}

const sendRating = async (rating, activityId) => {
  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/${rating}`, {
        activityId,
        ...params()
      }
    )
    return data
  } catch (error) {
    throw error
  }
}

const subscribeToNewsletter = async (data) => {
  const { email, activityId } = data

  try {
    await axios.post(`${process.env.REACT_APP_EXPERIENCES_API_URL}/contacts/wine-bot/subscribe-newsletter`, {
      name: '',
      email,
      resourceId: activityId,
      type: 'pipa'
    })
  } catch (error) {
    console.log(error)
  }
}


export {
  getStuff,
  sendRating,
  subscribeToNewsletter,
  sendResultClick,
}
